import {
  sitesResponseSchema, languagesResponseSchema,
  type SitesResponse, type LanguagesResponse,
  type SiteStatus 
} from '../types';
import {
  ApiClientError, buildUrl 
} from '@/errors';
import {
  authFetch, API_BASE_URL 
} from '@/lib/api-client';

// Sites
export interface SiteFilters {
  readonly status?: SiteStatus;
  readonly type?: string;
}

export async function getSites(filters?: SiteFilters): Promise<SitesResponse> {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  if (filters?.type) params.set('type', filters.type);

  const url = buildUrl(API_BASE_URL, '/v1/settings/sites', params);
  const response = await authFetch(url);
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch sites');
  }

  return sitesResponseSchema.parse(await response.json());
}

// Languages
export interface LanguageFilters {readonly enabled?: boolean;}

export async function getLanguages(filters?: LanguageFilters): Promise<LanguagesResponse> {
  const params = new URLSearchParams();
  if (filters?.enabled !== undefined) params.set('enabled', String(filters.enabled));

  const url = buildUrl(API_BASE_URL, '/v1/settings/languages', params);
  const response = await authFetch(url);
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch languages');
  }

  return languagesResponseSchema.parse(await response.json());
}
